import Input from '@nerdwallet/home-app-lib/input';

export default {
  creditScore: new Input({
    name: 'creditScore',
    type: 'string',
    viewConfig: {
      viewType: 'radio',
      items: [
        {
          label: 'Excellent (720 - 850)',
          value: 'excellent',
        },
        {
          label: 'Good (690 - 719)',
          value: 'good',
        },
        {
          label: 'Average (630 - 689)',
          value: 'average',
        },
        {
          label: 'Below average (580 - 629)',
          value: 'belowAvg',
        },
        {
          label: 'Poor (<580)',
          value: 'poor',
          next: { result: 'badCreditScore' },
        },
      ],
    },
  }),
  homeImprovementCost: new Input({
    name: 'homeImprovementCost',
    format: 'currency',
    type: 'integer',
  }),
  mortgageAmount: new Input({
    name: 'mortgageAmount',
    format: 'currency',
    type: 'integer',
  }),
  homeValue: new Input({
    name: 'homeValue',
    format: 'currency',
    type: 'integer',
  }),
  isRateLower: new Input({
    name: 'isRateLower',
    type: 'string',
    viewConfig: {
      viewType: 'radio',
      items: [
        {
          label: 'Yes, lower than the current rate',
          value: 'yes',
          next: { question: 'inputs.revolvingLineOfCredit' },
        },
        {
          label: 'No, higher than the current rate',
          value: 'no',
          next: { result: 'cashOutRefi' },
        },
      ],
    },
  }),
  revolvingLineOfCredit: new Input({
    name: 'revolvingLineOfCredit',
    type: 'string',
    viewConfig: {
      viewType: 'radio',
      items: [
        {
          label: 'Yes',
          value: 'yes',
          next: { result: 'heloc' },
        },
        {
          label: 'No',
          value: 'no',
          next: { result: 'homeEquityLoan' },
        },
      ],
    },
  }),
  loanPayOffTime: new Input({
    name: 'loanPayOffTime',
    type: 'string',
    viewConfig: {
      viewType: 'radio',
      items: [
        {
          label: 'At least 48 months (4 years)',
          value: 48,
        },
        {
          label: 'Between 22 months and 47 months',
          value: 47,
        },
        {
          label: 'Between 12 months and 21 months',
          value: 21,
        },
        {
          label: 'Less than 12 months (1 year)',
          value: 12,
        },
      ],
    },
  }),
};
